import { defineMessages } from 'react-intl';

export default defineMessages({
  expiredAd: {
    id: 'global_txt_expired_ad',
    defaultMessage:
      'The ad you are looking for has expired and is no longer available. You can find many similar ads using our search engine',
  },
  close: {
    id: 'global_close',
    defaultMessage: 'Close',
  },
});



// WEBPACK FOOTER //
// ./app/Serp/components/ExpiredAd/messages.js